module.exports = __webpack_public_path__ + "static/media/resultados.39ba0731.png";